import React from 'react';
import { useTranslation } from 'react-i18next';

function Hero() {
  const { t, i18n } = useTranslation();
  const cvUrl = i18n.language?.startsWith('en') ? '/CV_Cheikh_Ngom_EN.pdf' : '/CV_Cheikh_Ngom_FR.pdf';
  const canadaCvUrl = i18n.language?.startsWith('en') ? '/CV_Cheikh_Ngom_Canada_EN.pdf' : '/CV_Cheikh_Ngom_Canada_FR.pdf';
  const whatsappQuoteUrl = `https://wa.me/221785949274?text=${encodeURIComponent(t('whatsapp.quoteMessage'))}`;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" id="hero">
      <div className="hero-content">

        <div className="hero-brand">
          <span className="hero-brand-logo-wrap">
            <img
              src="/baobabsquare-logo.png"
              alt="BaobabSquare"
              className="hero-brand-logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </span>
          <span className="hero-brand-name">BaobabSquare</span>
        </div>
        <p className="hero-brand-tagline">{t('hero.brandTagline')}</p>

        <div className="hero-avatar-wrapper">
          <img
            src="/1778835220693.png"
            alt="Cheikh NGOM"
            className="hero-avatar"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>

        <h1 className="hero-title">{t('hero.name')}</h1>
        <h2 className="hero-subtitle">{t('hero.subtitle')}</h2>
        <p className="hero-description">{t('hero.description')}</p>

        <div className="hero-cta">
          <a
            className="cta-button whatsapp"
            href={whatsappQuoteUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('hero.cta.quote')}
          </a>
          <button
            className="cta-button primary"
            onClick={() => scrollToSection('contact')}
          >
            {t('hero.cta.contact')}
          </button>
          <a
            className="cta-button download"
            href={cvUrl}
            download
          >
            {t('hero.cta.download')}
          </a>
          <a
            className="cta-button download"
            style={{ background: 'linear-[#0f766e, #0d9488]', border: '1px solid #0f766e' }}
            href={canadaCvUrl}
            download
          >
            {t('hero.cta.downloadCanada')}
          </a>
        </div>

      </div>
    </section>
  );
}

export default Hero;
